export default {
    補充資料按鈕路徑: 'book/補充資料按鈕/',
}
